var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 160,
    viewBox: "0 0 105 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.22 112C99.2203 100.9 89.3203 89.8 76.1203 82.9C68.9203 79.3 61.4203 76.6 54.2203 74.2C43.4203 70 33.5203 66.4 26.0203 60.1C19.4203 54.7 16.7203 49.3 17.9203 43C19.1203 34.9 26.3203 28.3 38.0203 23.8C56.6203 17.2 78.2203 21.1 92.6203 35.2L103.72 23.8C85.4203 6.09999 56.0203 0.699989 32.9203 9.1C16.7203 14.5 4.72031 26.5 2.02031 40C0.220313 51.7 5.32031 63.7 16.1203 72.7C25.4203 80.5 37.7203 84.7 49.1203 88.9C56.3203 91.6 62.6203 94 68.3203 97C78.5203 102.1 84.8203 109.3 86.6203 116.5C88.1203 121 87.2203 124.6 84.8203 129.1C80.0203 136.3 71.6203 140.8 59.3203 142.6C42.5203 145 24.5203 140.2 12.2203 129.4L1.72031 141.1C14.9203 153.1 32.9203 159.1 50.9203 159.1C54.2203 159.1 57.8203 159.1 61.4203 158.5C77.6203 156.4 91.1203 148.6 98.0203 137.2C102.82 130 104.62 120.4 102.22 112Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerS);
export default __webpack_public_path__ + "static/media/LOWER_S.bd828804c793387f7128f75c127889f8.svg";
export { ForwardRef as ReactComponent };